module.exports = __webpack_public_path__ + "img/00-plan-c.ad4ad73f.png";